import {useEffect} from "react";
import API from "../helpers/apiHelpers";
import {useMediaQuery} from "@material-ui/core";

declare global {
    interface Window {
        Intercom: any;
    }
}

export const useIntercom = () => {
    let isMobile = useMediaQuery("(max-width:765px)");

    useEffect(() => {
        if (document.getElementsByClassName("intercom-lightweight-app-launcher").length > 0) {
            if (isMobile) {
                document.getElementsByClassName("intercom-lightweight-app-launcher")[0].setAttribute("style", "bottom: 60px");
            } else {
                document.getElementsByClassName("intercom-lightweight-app-launcher")[0].setAttribute("style", "bottom: 20px");
            }
        }
    }, [isMobile]);

    useEffect(() => {
        if (document.getElementsByClassName("intercom-lightweight-app-launcher").length === 0 && document.getElementsByClassName("intercom-app").length === 0) {
            if (API.userId) {
                bootIntercom(API.userId, JSON.parse(localStorage.getItem("auth")).email);
            }
        }
    }, []);
};

export const bootIntercom = async (userId?: number|string, email?: string) => {
    if(userId && email) {
        const profile = await API.getProfiles({
            userId: userId
        });
        const user = await API.getUserById(userId)
        if (profile.length) {
            await window.Intercom("boot", {
                app_id: "dgftalac",
                name: `${profile[0].firstName} ${profile[0].lastName}`,
                email: email,
                user_tag: user?.partnerEntity?.name || "Hello Ralphie"
            });
        } else {
            await window.Intercom("boot", {
                app_id: "dgftalac",
            });
        }
    } else {
        await window.Intercom("boot", {
            app_id: "dgftalac",
        });
    }
    setTimeout(() => {
        if (document.getElementsByClassName("intercom-lightweight-app-launcher").length > 0) {
            if (document.body.clientWidth <= 766) {
                document.getElementsByClassName("intercom-lightweight-app-launcher")[0].setAttribute("style", "bottom: 60px");
            } else {
                document.getElementsByClassName("intercom-lightweight-app-launcher")[0].setAttribute("style", "bottom: 20px");
            }
        }
    }, 3000);
};

export const hideIntercom = () => {
    window.Intercom("hide");
    window.Intercom("shutdown");
};

